/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/

/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR.*/



import AppointmentCalendarContent from "components/content/AppointmentCalendarContent";
import { H1 } from "components/generals/_Titles";
import Box from "components/generals/Box";
import DefaultDashboardLayout from "layouts/dashboard/DefaultDashboardLayout";
import { FC } from "react";
import { ViewTypeEnum } from "types/view.enum";
import { useTranslation } from "react-i18next";

/**
 * Appointments calendar page with scheduling functionality.
 * 
 * Features:
 * - Full calendar view with day/week/month views
 * - Interactive appointment creation by clicking calendar slots
 * - Drag-and-drop appointment rescheduling
 * - Color-coded appointments by status and provider
 * - Appointment filtering by provider, patient, status
 * - Quick appointment details view on click
 * - Integration with patient and provider records
 * 
 * @returns Appointments calendar page component
 */
const AppointmentsPage: FC = () => {
  const { t } = useTranslation();
  return (
    <DefaultDashboardLayout>
      <Box>
        <H1>{t("navRoutes.appointments")}</H1>
        <AppointmentCalendarContent viewType={ViewTypeEnum.PAGE} />
      </Box>
    </DefaultDashboardLayout>
  );
};

export default AppointmentsPage;

